import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/Nav.css";
import Hamburger from "./Hamburger";

const Nav = () => {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(false);
  const [headerClass, setHeaderClass] = useState("full-width-homepage")

  const toggleHamburger = () => {
    setOpen(!open);
    // console.log("hamburger clicked")
  };


  useEffect(() =>{
    if (window.location.pathname === "/"){
      setHeaderClass("full-width-homepage hidden")
      } else {
        setHeaderClass("full-width-homepage")
      }
  }, [page])

  window.onresize = (event) => {
    setOpen(false);
  };


  const setClose = () => {
    setOpen(false)
    setPage(!page)
  }

   useEffect(() => {
    const handleBackButton = (event) => {
      if (window.location.pathname === "/"){
        setHeaderClass("full-width-homepage hidden")
      }else {
        setHeaderClass("full-width-homepage")
      }
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []); 


  return (
    <div className="navigation">
      <ul>
      <div className={headerClass}><Link  to="/" onClick={setClose}><li className="rs">Riana Shahid</li></Link></div>
        <Link className="link-to-home" to="/" onClick={setClose}><li>Home</li></Link>
        <Link to="/about" onClick={setClose}><li>About</li></Link>
        <Link to="/projects" onClick={setClose}><li>Projects</li></Link>
        <Link to="/contact" onClick={setClose}><li>Contact</li></Link>
      </ul>
      {/* <div className="theme-toggle"></div> */}
      <div className="hamburger-container" onClick={toggleHamburger}>
        <Hamburger open={open} />
      </div>

      <style jsx>
        {`
          @media (max-width: 500px) {
            .navigation ul {
              display: ${open ? "block" : "none"};
              width: 30vw;
              margin-top: 4rem;
              position: absolute;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Nav;
